module.exports = __webpack_public_path__ + "img/a3uf8-7ona7.4f3cfdea.png";